import React from "react";

export default function CancellationPolicy() {
  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px" }}>
      <h1>Cancellation Policy</h1>

      <p>
        This Cancellation Policy explains how customers and service partners can
        cancel bookings on KaamHub.
      </p>

      <h2>Customer Cancellation</h2>
      <ul>
        <li>You may cancel a booking before the service partner starts the service.</li>
        <li>If the partner has already reached the location, cancellation charges may apply.</li>
      </ul>

      <h2>Partner Cancellation</h2>
      <ul>
        <li>Partners should avoid cancelling confirmed bookings.</li>
        <li>Repeated cancellations may result in account suspension.</li>
      </ul>

      <h2>Cancellation Charges</h2>
      <p>
        Cancellation charges, if any, will be shown before confirming the cancellation.
      </p>

      <h2>Contact Us</h2>
      <p>Email: support@kaamhub.in</p>
      <p>Website: https://kaamhub.in</p>

      <p>Last Updated: July 2026</p>
    </div>
  );
}
